/**
 * SagaMonitoringPage - Distributed transaction monitoring
 *
 * Surfaces the SagaMonitoringDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides real-time visibility into saga execution, compensation flows, and transaction health.
 *
 * Route: /admin/saga-monitoring
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconGitBranch } from '@tabler/icons-react';

import { SagaMonitoringDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function SagaMonitoringPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="violet">
            <IconGitBranch size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Saga Monitoring</Title>
            <Text size="sm" c="dimmed">
              Distributed transaction orchestration, compensation flows, and saga health
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <SagaMonitoringDashboard />
    </Container>
  );
}

export default SagaMonitoringPage;
